import authService from "../../../auth/AuthService";
import {
    addEditPricingTableActionTypes,
    apiActionsCountryPricing,
    apiActionsPricingTables,
    CountryPricingActionTypes,
    PricingTablesActionTypes
} from "../constants/PricingTablesActionConstants";

// Tables Actions V2
const deleteWarningForPricingV2 = () => ({
    type: apiActionsPricingTables.DELETE_WARNING_FOR_PRICING_V2
});

const updatedPricingTableV2 = () => ({
    type: PricingTablesActionTypes.UPDATED_PRICING_TABLE_REFRESH_V2,
});

const setOnePricingTableDataV2 = (pricingTableDetailsV2) => ({
    type: PricingTablesActionTypes.SET_PRICING_TABLE_DETAILS_V2,
    payload: {pricingTableDetailsV2}
});

const setPricingTablesDataV2 = (pricingTables) => ({
    type: PricingTablesActionTypes.SET_PRICING_TABLES_V2,
    payload: pricingTables
});

const toggleUploadPriceModal = () => ({
    type: addEditPricingTableActionTypes.TOGGLE_UPLOAD_PRICING_MODAL
});

const toggleAddPriceTableModalV2 = () => ({
    type: addEditPricingTableActionTypes.TOGGLE_ADD_PRICING_TABLE_MODAL_V2
});

const openEditPriceTableModalV2 = (pricingTableObjectV2, containsTieredPricingScheme) => ({
    type: addEditPricingTableActionTypes.OPEN_EDIT_PRICING_TABLE_MODAL_V2,
    payload: {pricingTableObjectV2, containsTieredPricingScheme}
});

const toggleEditPTModalV2 = () => ({
    type: addEditPricingTableActionTypes.TOGGLE_EDIT_PRICING_TABLE_MODAL_V2
});

const toggleSortPricingTableV2 = (sortKey) => ({
    type: PricingTablesActionTypes.TOGGLE_PRICING_TABLE_SORT_V2,
    payload: sortKey
})

// API Actions
const getOnePricingTableDetailV2 = (authToken, pricingID) => ({
    type: apiActionsPricingTables.GET_V2,
    payload: {authToken, pricingID}
})

const getPricingTablesDataV2 = (authToken) => ({
    type: apiActionsPricingTables.GET_ALL_V2,
    payload: {authToken},
});

const addNewPricingTableV2 = (authToken, pricingTableObjectV2) => ({
    type: apiActionsPricingTables.POST_V2,
    payload: {authToken, pricingTableObjectV2}
});

const editCurrentPricingTableV2 = (authToken, pricingTableObjectV2, pricingID) => ({
    type: apiActionsPricingTables.PUT_V2,
    payload: {authToken, pricingTableObjectV2, pricingID}
});

const deletePriceTableV2 = (authToken, pricingID) => ({
    type: apiActionsPricingTables.DELETE_V2,
    payload: {authToken, pricingID}
});

const uploadPricingData = (authToken, file) => ({
    type: apiActionsPricingTables.UPLOAD_PRICING_DATA,
    payload: {authToken, file}
});

// Form Actions
const validatePricingTableFormV2 = (pricingTableObjectV2) => ({
    type: addEditPricingTableActionTypes.VALIDATE_PRICING_TABLE_FORM_V2,
    payload: {pricingTableObjectV2}
});

const setPricingFormV2 = ({name, value}) => ({
    type: addEditPricingTableActionTypes.SETTING_PRICING_FORM_VALUE_V2,
    payload: {name, value},
});

const setPricingFormDropdownV2 = (option, change_obj) => ({
    type: addEditPricingTableActionTypes.SETTING_PRICING_FORM_DROPDOWN_V2,
    payload: {option, change_obj},
});

const setPricingFormDescriptionV2 = ({name, value}) => ({
    type: addEditPricingTableActionTypes.SETTING_PRICING_FORM_DESCRIPTION_V2,
    payload: {name, value}
})

// Form Actions
const setCountryPricingFormV2 = ({name, value}) => ({
    type: addEditPricingTableActionTypes.SETTING_COUNTRY_PRICING_FORM_VALUE_V2,
    payload: {name, value},
});

// Country Pricing Actions
const setCountryPricingTableDataV2 = (countryPricesV2) => ({
    type: CountryPricingActionTypes.SET_COUNTRY_PRICING_DETAILS_V2,
    payload: {countryPricesV2}
});

// API Actions
const getCurrentCountryPricingV2 = (authToken, pricingID) => ({
    type: apiActionsCountryPricing.GET_V2,
    payload: {authToken, pricingID}
})

// Pricing Tables Functions
export function toggleDeletePricingTableModalV2() {
    return (dispatch) => {
        dispatch(deleteWarningForPricingV2())
    }
}

export function pricingTablesTableDataSuccessV2(pricingTables) {
    return (dispatch) => {
        dispatch(setPricingTablesDataV2(pricingTables));
    }
}

export function pricingTableDetailSuccessV2(pricingTableDetailsV2) {
    return (dispatch) => {
        dispatch(setOnePricingTableDataV2(pricingTableDetailsV2));
    }
}

export function updatedPricingTableRefreshV2() {
    return (dispatch) => {
        dispatch(updatedPricingTableV2())
    }
}

export function toggleUploadPricingModal() {
    return (dispatch) => {
        dispatch(toggleUploadPriceModal())
    }
}

export function toggleAddPricingTableModalV2() {
    return (dispatch) => {
        dispatch(toggleAddPriceTableModalV2())
    }
}

export function openEditPricingTableModalV2(pricingTableObjectV2, containsTieredPricingScheme) {
    return (dispatch) => {
        dispatch(openEditPriceTableModalV2(pricingTableObjectV2, containsTieredPricingScheme))
    }
}

export function togglePricingTableSortV2(sortKey) {
    return (dispatch) => {
        dispatch(toggleSortPricingTableV2(sortKey))
    }
}

const ptGlobalSearchV2 = (value) => ({
    type: PricingTablesActionTypes.PRICING_TABLE_GLOBAL_SEARCH_V2,
    payload: value
})

export function pricingTablesSearchV2(value) {
    return (dispatch) => {
        dispatch(ptGlobalSearchV2(value))
    }
}


// API Functions
export function fetchOnePricingTableV2(pricingID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getOnePricingTableDetailV2(authToken, pricingID));
    }
}

export function fetchPricingTablesTableDataV2() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getPricingTablesDataV2(authToken));
    }
}

export function addPricingTableV2(pricingTableObjectV2) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(addNewPricingTableV2(authToken, pricingTableObjectV2))
    }
}

export function editPricingTableV2(pricingTableObjectV2, pricingID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(editCurrentPricingTableV2(authToken, pricingTableObjectV2, pricingID))
    }
}

export function deletePricingTableV2(pricingID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(deletePriceTableV2(authToken, pricingID))
    }
}

export function toggleEditPricingTableModalV2() {
    return (dispatch) => {
        dispatch(toggleEditPTModalV2())
    }
}

export function uploadPricingTableData(file) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(uploadPricingData(authToken, file))
    }
}

// Form Functions
export function setPricingFormValuesV2({name, value}) {
    return (dispatch) => {
        dispatch(setPricingFormV2({name, value}));
    }
}

export function setPricingFormDropdownValuesV2(option, change_obj) {
    return (dispatch) => {
        dispatch(setPricingFormDropdownV2(option, change_obj));
    }
}

export function setPricingFormDescriptionValueV2({name, value}) {
    return (dispatch) => {
        dispatch(setPricingFormDescriptionV2({name, value}))
    }
}

export function validatePricingTableV2(pricingTableObjectV2) {
    return (dispatch) => {
        dispatch(validatePricingTableFormV2(pricingTableObjectV2))
    }
}

// Form Functions
export function setCountryPricingFormValuesV2({name, value}) {
    return (dispatch) => {
        dispatch(setCountryPricingFormV2({name, value}));
    }
}
// Country Pricing Functions
export function countryPricingRecordsSuccessV2(countryPricesV2) {
    return (dispatch) => {
        dispatch(setCountryPricingTableDataV2(countryPricesV2));
    }
}

const editFlatPricingValueV2 = (price) => ({
    type: CountryPricingActionTypes.EDIT_FLAT_PRICE_V2,
    payload: price
})

const editVolumePricingValueV2 = (value, name, idx) => ({
    type: CountryPricingActionTypes.EDIT_VOLUME_TIER_VALUES_V2,
    payload: {value, name, idx}
})

const addVolumeTierV2 = () => ({
    type: CountryPricingActionTypes.ADD_VOLUME_TIER_V2,
});

const deleteLastVolumeTierV2 = () => ({
    type: CountryPricingActionTypes.DELETE_VOLUME_TIER_V2
})

const validateEditCPFormV2 = (countryPricingObjectV2) => ({
    type: CountryPricingActionTypes.VALIDATE_EDIT_COUNTRY_PRICING_FORM_V2,
    payload: { countryPricingObjectV2 }
})

const editCountryPricingV2 = (authToken, countryPricingID, countryPricingObjectV2) => ({
    type: apiActionsCountryPricing.PUT_V2,
    payload: {authToken, countryPricingID, countryPricingObjectV2}
});

const addCountryPricingV2 = (authToken, countryPricingObjectV2) => ({
    type: apiActionsCountryPricing.POST_V2,
    payload: {authToken, countryPricingObjectV2}
});

const deleteWarningForCountryPricingV2 = (countryPricingID) => ({
    type: CountryPricingActionTypes.DELETE_WARNING_FOR_COUNTRY_PRICING_V2,
    payload: countryPricingID
});

const closeCountryPriceModalV2 = () => ({
    type: CountryPricingActionTypes.CLOSE_COUNTRY_PRICING_MODAL_V2
});

const openEditCountryPriceModalV2 = (countryPriceObject) => ({
    type: CountryPricingActionTypes.OPEN_EDIT_COUNTRY_PRICING_MODAL_V2,
    payload: countryPriceObject
});

const toggleAddCountryPriceModalV2 = (pricingID, pricingScheme, pricingJsonKey) => ({
    type: CountryPricingActionTypes.TOGGLE_ADD_COUNTRY_PRICING_MODAL_V2,
    payload: {pricingID, pricingScheme, pricingJsonKey}
});

const toggleAddNewPricingSchemeV2 = (pricingID, volumeAggregationType) => ({
    type: CountryPricingActionTypes.TOGGLE_ADD_PRICING_SCHEME_MODAL_V2,
    payload: { pricingID, volumeAggregationType }
});

const deleteCountryPricingV2 = (authToken, pricingID, countryPricingID) => ({
    type: apiActionsCountryPricing.DELETE_V2,
    payload: {authToken, pricingID, countryPricingID}
});

const setCountryValueV2 = ({ country }) => ({
    type: CountryPricingActionTypes.SET_COUNTRY_V2,
    payload: { country }
});

const setPricingSchemeV2 = ({ pricingScheme }) => ({
    type: CountryPricingActionTypes.SET_PRICING_SCHEME_V2,
    payload: { pricingScheme }
});

export function editFlatPricingV2(price) {
    return (dispatch) => {
        dispatch(editFlatPricingValueV2(price))
    }
}

export function editVolumePricingV2(value, name, idx) {
    return (dispatch) => {
        dispatch(editVolumePricingValueV2(value, name, idx))
    }
}

export function validateEditCountryPricingFormV2(countryPricingObjectV2) {
    return (dispatch) => {
        dispatch(validateEditCPFormV2(countryPricingObjectV2))
    }
}

export function openEditCountryPricingModalV2(countryPrices) {
    return (dispatch) => {
        dispatch(openEditCountryPriceModalV2(countryPrices))
    }
}

export function selectCountryForPricingV2({ country }) {
    return (dispatch) => {
        dispatch(setCountryValueV2({ country }))
    }
}

export function selectPricingSchemeV2({ pricingScheme }) {
    return (dispatch) => {
        dispatch(setPricingSchemeV2({ pricingScheme }))
    }
}

export function addNewVolumeTierV2() {
    return (dispatch) => {
        dispatch(addVolumeTierV2())
    }
}

export function deleteVolumeTierV2() {
    return (dispatch) => {
        dispatch(deleteLastVolumeTierV2())
    }
}

export function toggleDeleteCountryPriceModalV2(countryPricingID) {
    return (dispatch) => {
        dispatch(deleteWarningForCountryPricingV2(countryPricingID))
    }
}

export function closeCountryPricingModalV2() {
    return (dispatch) => {
        dispatch(closeCountryPriceModalV2())
    }
}

// API Functions
export function fetchCountryPricesV2(pricingID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getCurrentCountryPricingV2(authToken, pricingID));
    }
}

export function editCountryLevelPricingV2(countryPricingID, countryPricingObjectV2) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(editCountryPricingV2(authToken, countryPricingID, countryPricingObjectV2))
    }
}

export function addCountryLevelPricingV2(countryPricingObjectV2) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(addCountryPricingV2(authToken, countryPricingObjectV2))
    }
}

export function deleteCountryLevelPricingV2(pricingID, countryPricingID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(deleteCountryPricingV2(authToken, pricingID, countryPricingID))
    }
}

export function toggleAddCountryPricingModalV2(pricingID, pricingScheme, pricingJsonKey) {
    return (dispatch) => {
        dispatch(toggleAddCountryPriceModalV2(pricingID, pricingScheme, pricingJsonKey))
    }
}

export function toggleAddPricingSchemeModalV2(pricingID, volumeAggregationType) {
    return (dispatch) => {
        dispatch(toggleAddNewPricingSchemeV2(pricingID, volumeAggregationType))
    }
}

const unmountPricingTableDetailV2 = () => ({
    type: PricingTablesActionTypes.CLEAR_PRICING_DETAILS_V2,
});
export function unmountPricingDetailPageV2() {
    return (dispatch) => {
        dispatch(unmountPricingTableDetailV2());
    }
}

const exports = {
    addEditPricingTableActionTypes,
    PricingTablesActionTypes,
    apiActionsPricingTables,
    CountryPricingActionTypes,
}

export default exports;
